import React from 'react'
import PropTypes from 'prop-types'

import Styles from './index.scss'

const Add = props => (
  <div className="page-content">
    <form
      name="signup-form"
      className="signup-form"
      onSubmit={props.submitForm}
    >
      <h3 className="form-title font-green">
      Add User and Profile Panel <br /><small>User Registration</small>
      </h3>
      <div className="form-group">
        <br />
        <label htmlFor="firstName" className="control-label">First Name</label>
        <input
          className="form-control form-control-solid placeholder-no-fix"
          type="text"
          id="firstName"
          name="firstName"
          placeholder="Please fill out this field"
          value={props.firstName}
          onChange={e => props.onInputChange(e.target)}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="lastName" className="control-label">Last Name</label>
        <input
          className="form-control form-control-solid placeholder-no-fix"
          type="text"
          id="lastName"
          name="lastName"
          placeholder="Please fill out this field"
          value={props.lastName}
          onChange={e => props.onInputChange(e.target)}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="email" className="control-label">Email</label>
        <input
          className="form-control form-control-solid placeholder-no-fix"
          type="email"
          id="email"
          name="email"
          placeholder="Please fill out this field"
          value={props.email}
          onChange={e => props.onInputChange(e.target)}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="password" className="control-label">
          Password
        </label>
        <input
          className="form-control form-control-solid placeholder-no-fix"
          disabled
          id="password"
          name="password"
          placeholder="Click the auto-generate button"
          value={props.password}
          required
          title="Click the auto-generate button"
        />
        <br />
        <button
          type="submit"
          className="btn red uppercase"
          onClick={props.generatePassword}
        >
        Auto-Generate
        </button>
      </div>
      <hr />
      <h3 className="form-title font-green">
        <small>User&apos;s Profile Registration</small>
      </h3>
      <br />
      <div className="form-group">
        <label htmlFor="profileName" className="control-label">Profile Name</label>
        <input
          className="form-control form-control-solid placeholder-no-fix"
          type="text"
          id="profileName"
          name="profileName"
          value={props.profileName}
          placeholder="Please fill out this field"
          onChange={e => props.onInputChange(e.target)}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="profileId" className="control-label">Profile ID</label>
        <input
          className="form-control form-control-solid placeholder-no-fix"
          type="text"
          id="profileId"
          name="profileId"
          value={props.profileId}
          placeholder="Please fill out this field (minimum of 4 characters)"
          onChange={e => props.onInputChange(e.target)}
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="control-label">Country</label>
        <select
          className="form-control"
          id="country"
          onChange={props.handleSelectedCountry}
          required
        >
          <option>Select Country</option>
          {props.selectionsCountry.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
        ))}
        </select>
      </div>
      <div className="form-group">
        <label htmlFor="control-label">City</label>
        <select
          className="form-control"
          id="city"
          name="city"
          onChange={e => props.onInputChange(e.target)}
          required
        >
          <option>Select City</option>
          {props.selectionsCity.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      <div className="form-group">
        <label htmlFor="control-label">Default Feature</label>
        <select
          className="form-control"
          onChange={e => props.onInputChange(e.target)}
          name="defaultFeature"
          required
        >
          <option value="">Select Default Feature</option>
          <option value="product">Creator</option>
          <option value="project">Client</option>
        </select>
      </div>
      {props.isError && (
        <div className={`${Styles.alert} alert-danger`}>
          <small><strong>Warning!</strong> Reason: {props.errorMessage}</small>
        </div>
      )}
      <div className="form-group">
        <button type="submit" className="btn green uppercase">
        Register User & User-Profile
      </button>
      </div>
    </form>
  </div>
)

Add.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  profileName: PropTypes.string.isRequired,
  profileId: PropTypes.string.isRequired,

  onInputChange: PropTypes.func.isRequired,
  generatePassword: PropTypes.func.isRequired,
  handleSelectedCountry: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,

  isError: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,

  selectionsCountry: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectionsCity: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
}

export default Add
